/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createWebBuyerIntent} from '../api'

export const useMutationCreateWebBuyerIntent = createReactQueryMutationHook('createWebBuyerIntent', createWebBuyerIntent)
